module.exports = __webpack_public_path__ + "img/no-img.fa081a80.svg";